import { useMemo } from 'react';
import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { useBreakpoints } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { meta } from '../../../meta';
import { Category } from './Category';

export const CategoryList = ({
  categories: userCategories,
  selectedCategory,
  onCategorySelect
}) => {
  const [breakpoints, componentElementRef] = useBreakpoints(728);
  const { t } = useTranslation();
  const { filtersTextColor } = useSettings();

  const colors = useMemo(
    () => ({
      activeBackground: getColorWithAlpha(filtersTextColor, 0.05),
      inactiveBorder: getColorWithAlpha(filtersTextColor, 0.1),
      inactiveText: getColorWithAlpha(filtersTextColor, 0.5),
      filtersText: filtersTextColor
    }),
    [filtersTextColor]
  );

  const categories = [
    {
      name: t('All'),
      id: '*'
    },
    ...(userCategories || [])
  ];

  return (
    <Container ref={componentElementRef} $isMobile={breakpoints[728]}>
      {categories.map(
        (category) =>
          category.name && (
            <Category
              key={category.id}
              size={breakpoints[728] ? 'xsmall' : 'xmedium'}
              text={category.name}
              active={category.id === selectedCategory}
              colors={colors}
              onClick={() => onCategorySelect(category.id)}
            />
          )
      )}
    </Container>
  );
};

const Container = styled.div.attrs(({ $isMobile }) => ({
  className: classNames(`${meta.stylePrefix}-category-list-component`, {
    [`${meta.stylePrefix}-category-list-b728`]: $isMobile
  })
}))`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  gap: 12px;

  ${({ $isMobile }) => !$isMobile && `justify-content: center;`}
`;
